import { QueryKey } from "@/api";
import { Api } from "@/api/Api";
import { useAuth } from "@/auth";
import { getMarketplaceAssetId } from "@/marketplace/utils";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";

export function useMarketplaceImage(imageUrl: string | null | undefined): string | undefined {
  const { session } = useAuth();
  const fileId = imageUrl ? getMarketplaceAssetId(imageUrl) : undefined;
  const [objectUrl, setObjectUrl] = useState<string>();

  const { data: blob } = useQuery({
    queryKey: [QueryKey.MARKETPLACE_ASSET, fileId],
    queryFn: ({ signal }) => {
      if (fileId === undefined) {
        throw new Error("fileId is required");
      }
      return Api.marketplace.getMarketplaceAsset({ fileId }, { signal });
    },
    enabled: !!fileId && !!session?.token,
    staleTime: Number.POSITIVE_INFINITY,
  });

  useEffect(() => {
    if (!blob) {
      setObjectUrl(undefined);
      return;
    }

    const url = URL.createObjectURL(blob);
    setObjectUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [blob]);

  return objectUrl;
}
